import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL, BRAND } from "@/lib/constants";

export default function Datenschutz() {
  return (
    <div className="bg-white min-h-screen" data-testid="datenschutz-page">
      <header className="border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="datenschutz-back-home">
            <img src={LOGO_URL} alt="Rosenberg Objektservice" className="h-14 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-wider font-semibold text-[#0A0A0A] hover:text-[#8A151B] transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-10 bg-[#8A151B]" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
            Rechtliches
          </span>
        </div>

        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-[#0A0A0A]">
          Datenschutz&shy;erklärung
        </h1>

        <p className="mt-6 text-sm text-neutral-500 uppercase tracking-wider">
          Informationen gemäß Art. 13 DSGVO
        </p>

        <div className="mt-12 space-y-10 text-base text-neutral-700 leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              1. Verantwortlicher
            </h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website
              im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
            </p>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1">
              <p className="font-semibold text-[#0A0A0A]">{BRAND.owner}</p>
              <p>Rosenberg Objektservice</p>
              <p>Weserstraße 3</p>
              <p>63322 Rödermark</p>
              <p>
                Telefon:{" "}
                <a href={`tel:${BRAND.phoneIntl}`} className="text-[#8A151B] hover:underline">
                  {BRAND.phone}
                </a>
              </p>
              <p>
                E-Mail:{" "}
                <a href={`mailto:${BRAND.email}`} className="text-[#8A151B] hover:underline">
                  {BRAND.email}
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              2. Erhebung und Speicherung personenbezogener Daten
            </h2>
            <h3 className="font-semibold text-[#0A0A0A] mt-4">
              a) Beim Besuch der Website
            </h3>
            <p className="mt-2">
              Beim Aufrufen unserer Website werden durch den Browser
              automatisch Informationen an den Server gesendet. Diese
              Informationen werden temporär in einem sogenannten Log-File
              gespeichert: IP-Adresse, Datum und Uhrzeit des Zugriffs,
              Zeitzonendifferenz zur Greenwich Mean Time (GMT), Inhalt der
              Anforderung (konkrete Seite), Zugriffsstatus / HTTP-Statuscode,
              jeweils übertragene Datenmenge, Website, von der die Anforderung
              kommt, Browser, Betriebssystem und dessen Oberfläche, Sprache
              und Version der Browsersoftware.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse an der technisch fehlerfreien Auslieferung und
              Sicherheit der Website).
            </p>

            <h3 className="font-semibold text-[#0A0A0A] mt-6">
              b) Kontaktformular & Wertschätzung
            </h3>
            <p className="mt-2">
              Wenn Sie unser Kontaktformular oder das Schätzungs-Widget
              nutzen, erheben wir folgende Daten: Name, E-Mail-Adresse,
              Telefonnummer (optional), Anliegen und Nachricht bzw.
              Angaben zu Ihrer Immobilie (Objektart, Größe, Ort).
            </p>
            <p className="mt-2">
              Diese Daten verwenden wir ausschließlich zur Bearbeitung
              Ihrer Anfrage. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO
              (Anbahnung eines Vertragsverhältnisses) bzw. Art. 6 Abs. 1
              lit. a DSGVO (Einwilligung).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              3. Weitergabe von Daten
            </h2>
            <p>
              Eine Übermittlung Ihrer persönlichen Daten an Dritte zu
              anderen als den im Folgenden aufgeführten Zwecken findet
              nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte
              weiter, wenn:
            </p>
            <ul className="mt-3 space-y-2 list-disc list-inside">
              <li>Sie Ihre ausdrückliche Einwilligung erteilt haben (Art. 6 Abs. 1 lit. a DSGVO),</li>
              <li>die Weitergabe zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist (Art. 6 Abs. 1 lit. f DSGVO),</li>
              <li>eine gesetzliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO),</li>
              <li>dies zur Vertragsabwicklung mit Ihnen erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO).</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              4. Cookies
            </h2>
            <p>
              Diese Website verwendet ausschließlich technisch notwendige
              Cookies, um die Grundfunktionen der Seite bereitzustellen.
              Es werden keine Tracking- oder Marketing-Cookies eingesetzt,
              die einer ausdrücklichen Einwilligung bedürfen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              5. Eingesetzte Dienste & Auftragsverarbeiter
            </h2>
            <p>
              Im Rahmen unserer Tätigkeit als Immobilienmakler und
              Objektdienstleister setzen wir folgende Drittanbieter ein,
              an die personenbezogene Daten unserer Kunden weitergegeben
              werden können. Mit allen verarbeitenden Stellen bestehen,
              soweit erforderlich, Auftragsverarbeitungsverträge nach
              Art. 28 DSGVO.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] mt-6">
              a) Lexware Office (Buchhaltung & Kunden-CRM)
            </h3>
            <p className="mt-2">
              Wir nutzen Lexware Office der Haufe Service Center GmbH,
              Munzinger Straße 9, 79111 Freiburg, für die Erstellung von
              Rechnungen, die Verwaltung von Kundenkontakten sowie für
              unsere allgemeine Buchhaltung. Verarbeitet werden:
              Stammdaten (Name, Anschrift, Kontaktdaten), Rechnungs- und
              Vertragsdaten.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
              sowie Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Aufbewahrungs-
              und Buchführungspflichten, §§ 147 AO, 257 HGB).
            </p>

            <h3 className="font-semibold text-[#0A0A0A] mt-6">
              b) Google Kalender (Terminverwaltung)
            </h3>
            <p className="mt-2">
              Für die Planung und Verwaltung von Besichtigungs- und
              Beratungsterminen setzen wir Google Calendar der Google
              Ireland Limited, Gordon House, Barrow Street, Dublin 4,
              Irland, ein. Hierbei werden Name, ggf. Telefonnummer und
              die Adresse des Besichtigungsobjekts in unserem Kalender
              gespeichert.
            </p>
            <p className="mt-2">
              Eine Übermittlung in Drittländer (USA) kann durch Google
              im Rahmen der Verarbeitung nicht ausgeschlossen werden.
              Google ist gemäß EU-US Data Privacy Framework zertifiziert,
              so dass ein angemessenes Datenschutzniveau im Sinne des
              Art. 45 DSGVO sichergestellt ist.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO
              (Vertragsanbahnung und -durchführung).
            </p>

            <h3 className="font-semibold text-[#0A0A0A] mt-6">
              c) Apple iCloud (Pages & Numbers)
            </h3>
            <p className="mt-2">
              Zur Erstellung von Exposés, Notizen und Kalkulationen
              nutzen wir Apple Pages und Numbers, deren Inhalte über
              iCloud der Apple Distribution International Ltd., Hollyhill
              Industrial Estate, Hollyhill, Cork, Irland, synchronisiert
              werden. Hierbei können Kundendaten (z.B. Objektdaten,
              Notizen zu Anfragen) verarbeitet werden.
            </p>
            <p className="mt-2">
              Eine Übermittlung in Drittländer (USA) kann nicht
              ausgeschlossen werden. Apple ist gemäß EU-US Data Privacy
              Framework zertifiziert.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse an effizienter Bürokommunikation und
              Dokumentation).
            </p>

            <h3 className="font-semibold text-[#0A0A0A] mt-6">
              d) Resend (E-Mail-Versand)
            </h3>
            <p className="mt-2">
              Zur automatisierten Zustellung von Benachrichtigungen über
              eingehende Kontakt- und Schätzungs-Anfragen nutzen wir den
              Dienst <strong>Resend</strong>, betrieben von Plus Five Five, Inc.,
              2261 Market Street #5039, San Francisco, CA 94114, USA.
              Beim Absenden eines Formulars werden die von Ihnen
              eingegebenen Daten (Name, E-Mail-Adresse, Telefon, Anliegen,
              Nachricht bzw. Angaben zu Ihrer Immobilie) an Resend
              übermittelt, dort verarbeitet und als E-Mail an unser
              Postfach zugestellt.
            </p>
            <p className="mt-2">
              Resend speichert Kundendaten in den USA. Es besteht ein
              Auftragsverarbeitungsvertrag (Data Processing Agreement) nach
              Art. 28 DSGVO, einschließlich EU-Standardvertragsklauseln
              (Standard Contractual Clauses) gemäß Art. 46 Abs. 2 lit. c
              DSGVO. Plus Five Five, Inc. ist zudem nach dem
              <strong> EU-US Data Privacy Framework</strong> zertifiziert, so
              dass ein angemessenes Datenschutzniveau im Sinne des
              Art. 45 DSGVO sichergestellt ist.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO
              (Vertragsanbahnung) sowie Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse an einer zuverlässigen
              Anfragebearbeitung). Weitere Informationen unter{" "}
              <a
                href="https://resend.com/legal/privacy-policy"
                target="_blank"
                rel="noreferrer"
                className="text-[#8A151B] hover:underline"
              >
                resend.com/legal/privacy-policy
              </a>.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] mt-6">
              e) Hosting & Datenbank (Emergent)
            </h3>
            <p className="mt-2">
              Diese Website sowie die zugehörige Anwendung werden auf der
              Plattform <strong>Emergent</strong> der Emergent Labs Inc.,
              San Francisco, CA, USA, gehostet. Personenbezogene Daten,
              die Sie über das Kontaktformular oder das Schätzungs-Widget
              eingeben, werden auf den Servern dieses Dienstleisters in
              einer Datenbank (MongoDB) gespeichert. Beim Aufruf der
              Website werden zudem technische Daten (siehe Punkt 2 a)
              im Rahmen der Server-Logs verarbeitet.
            </p>
            <p className="mt-2">
              Eine Übermittlung in Drittländer (USA) findet statt.
              Die Datenverarbeitung erfolgt auf Grundlage eines
              Auftragsverarbeitungsvertrags nach Art. 28 DSGVO unter
              Einbeziehung der EU-Standardvertragsklauseln nach
              Art. 46 Abs. 2 lit. c DSGVO.
            </p>
            <p className="mt-2">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
              Interesse am sicheren und zuverlässigen Betrieb dieser
              Website) sowie Art. 6 Abs. 1 lit. b DSGVO bezüglich der
              über Formulare übermittelten Daten.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              6. Speicherdauer
            </h2>
            <p>
              Personenbezogene Daten, die uns über das Kontaktformular
              oder das Schätzungs-Widget mitgeteilt werden, werden in
              unserer Datenbank gespeichert und{" "}
              <strong>automatisch nach 14 Tagen vollständig gelöscht</strong>{" "}
              (technisch umgesetzt über einen TTL-Index in MongoDB). Die
              Bearbeitung einer eingehenden Anfrage erfolgt regelmäßig
              innerhalb dieses Zeitraums per E-Mail. Sollte für die
              weitere Korrespondenz oder Vertragsanbahnung eine längere
              Speicherung erforderlich sein, geschieht dies ausschließlich
              außerhalb der Website (z.B. in unserem E-Mail-Postfach oder
              in Lexware Office), bis der Zweck entfällt.
            </p>
            <p className="mt-3">
              Gesetzliche Aufbewahrungspflichten, insbesondere nach
              §§ 147 AO und 257 HGB für Vertrags- und Rechnungsunterlagen,
              bleiben hiervon unberührt.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              7. Ihre Rechte
            </h2>
            <p>Sie haben gegenüber uns folgende Rechte:</p>
            <ul className="mt-3 space-y-2 list-disc list-inside">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
              <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
            </ul>
            <p className="mt-4">
              Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung
              an die oben genannten Kontaktdaten.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              8. Beschwerderecht
            </h2>
            <p>
              Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde
              über die Verarbeitung Ihrer personenbezogenen Daten zu
              beschweren. Zuständig in Hessen ist:
            </p>
            <div className="mt-4 border-l-2 border-[#8A151B] pl-6 space-y-1">
              <p className="font-semibold text-[#0A0A0A]">
                Der Hessische Beauftragte für Datenschutz und
                Informationsfreiheit
              </p>
              <p>Postfach 31 63</p>
              <p>65021 Wiesbaden</p>
              <p>
                <a
                  href="https://datenschutz.hessen.de"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#8A151B] hover:underline"
                >
                  datenschutz.hessen.de
                </a>
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold uppercase tracking-wider text-[#0A0A0A] mb-4">
              9. Datensicherheit
            </h2>
            <p>
              Wir verwenden innerhalb des Website-Besuchs das verbreitete
              SSL-/TLS-Verfahren in Verbindung mit der jeweils höchsten
              Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird.
              Eine 100%ige Sicherheit der Datenübertragung im Internet
              kann jedoch nicht garantiert werden.
            </p>
          </section>

          <section className="pt-8 border-t border-neutral-200">
            <p className="text-sm text-neutral-500">
              Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-neutral-200 py-10">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs uppercase tracking-wider text-neutral-500">
          <p>© {new Date().getFullYear()} Rosenberg Objektservice</p>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-[#8A151B] transition-colors">
              Startseite
            </Link>
            <Link to="/impressum" className="hover:text-[#8A151B] transition-colors" data-testid="datenschutz-footer-impressum">
              Impressum
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
